import { useEffect, useState } from 'react';
import { validateRequired, validatePercentage, ErrorMessage } from '../../utlis/function.js';
import CommonLoader from '../common/CommonLoader.jsx';

const EditClubDetailsModal = ({ onClose, onSave, initialData = {} , isLoading}) => {
  const [formData, setFormData] = useState({
    male:  '',
    female:  '',
    others: ''
  });

  useEffect(() => {
    setFormData({
      male: initialData.male || '',
      female: initialData.female || '',
      others: initialData.others || ''
    });
  },[initialData])
  const [errors, setErrors] = useState({});
  
  

  const handleInputChange = (field, value) => {
    if(value.length === 1 && value ==="0"){
      return;
    }
    // Remove any non-numeric characters except for numbers
    const numericValue = value.replace(/[^0-9]/g, '');
    setFormData(prev => ({
      ...prev,
      [field]: numericValue
    }));
    
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const validateFields = () => {
    const newErrors = {};
    const male = Number(formData.male);
const female = Number(formData.female);
    
    // Validate Male field
    if (!validateRequired(formData.male)) {
      newErrors.male = 'Male percentage is required';
    } else if (!validatePercentage(formData.male)) {
      newErrors.male = 'Please enter a valid percentage (0-100)';
    }

    // Validate Female field
    if (!validateRequired(formData.female)) {
      newErrors.female = 'Female percentage is required';
    } else if (!validatePercentage(formData.female)) {
      newErrors.female = 'Please enter a valid percentage (0-100)';
    }
      if (
    !isNaN(male) &&
    !isNaN(female) &&
    male + female !== 100
  ) {
    newErrors.male = 'Male + Female must equal 100%';
    newErrors.female = 'Male + Female must equal 100%';
  }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  

  const handleSave = async() => {
    if (validateFields() && onSave) {

     await onSave(formData);
    }
  };



  const getProgressWidth = (value) => {
    if (!value) return '0%';
    const numValue = parseInt(value);
    return `${Math.min(numValue, 100)}%`;
  };

  return (
    <div className="fixed inset-0 bg-[#000000b5] flex items-center justify-center z-50">
      <div className="bg-white rounded-[20px] max-w-[624px] w-full mx-4 relative overflow-hidden">
        {isLoading && <CommonLoader fullScreen/>}

        {/* Content */}
        <div className="p-8">
          {/* Title */}
          <h2 className="text-[30px] font-semibold text-black mb-2 tracking-[0] leading-[normal]">
            Gender Distribution
          </h2>

          {/* Description */}
          <p className="text-[20px] font-normal text-[#666666] mb-8">
            Enter the percentage breakdown of the average audience by gender.
          </p>

          {/* Male Input */}
          <div className="mb-6">
            <label className="block text-[16px] font-medium text-black mb-3">
              Male%
            </label>
            <div className="relative">
              <input
                type="text"
                value={formData.male}
                onChange={(e) => handleInputChange('male', e.target.value)}
                placeholder="25"
                maxLength={30}
                className={`w-full h-[48px] px-4 border-1 rounded-full text-base font-normal text-black placeholder-[#999999] focus:outline-none focus:border-[#0A5F73] transition-colors ${
                  errors.male ? 'border-red-500' : 'border-[#C5C5C5]'
                }`}
              />
              {/* Progress bar under input */}
              {/* <div className="mt-2 h-[4px] bg-[#E5E5E5] rounded-full overflow-hidden">
                <div
                  className="h-full bg-[#4CAF50] rounded-full transition-all duration-300"
                  style={{ width: getProgressWidth(formData.male) }}
                ></div>
              </div> */}
            </div>
            <ErrorMessage message={errors.male} />
          </div>

          {/* Female Input */}
          <div className="mb-6">
            <label className="block text-[16px] font-medium text-black mb-3">
              Female%
            </label>
            <div className="relative">
              <input
                type="text"
                value={formData.female}
                onChange={(e) => handleInputChange('female', e.target.value)}
                placeholder="45"
                maxLength={30}
                className={`w-full h-[48px] px-4 border-1 rounded-full text-base font-normal text-black placeholder-[#999999] focus:outline-none focus:border-[#0A5F73] transition-colors ${
                  errors.female ? 'border-red-500' : 'border-[#C5C5C5]'
                }`}
              />
              {/* Progress bar under input */}
              {/* <div className="mt-2 h-[4px] bg-[#E5E5E5] rounded-full overflow-hidden">
                <div
                  className="h-full bg-[#0A5F73] rounded-full transition-all duration-300"
                  style={{ width: getProgressWidth(formData.female) }}
                ></div>
              </div> */}
            </div>
            <ErrorMessage message={errors.female} />
          </div>

          {/* Others Input */}
          {/* <div className="mb-8">
            <label className="block text-[16px] font-medium text-black mb-3">
              Others
            </label>
            <div className="relative">
              <input
                type="text"
                value={formData.others}
                onChange={(e) => handleInputChange('others', e.target.value)}
                placeholder="25%"
                className="w-full h-[48px] px-4 border-1 border-[#C5C5C5] rounded-full text-base font-normal text-black placeholder-[#999999] focus:outline-none focus:border-[#0A5F73] transition-colors"
              />
              <div className="mt-2 h-[4px] bg-[#E5E5E5] rounded-full overflow-hidden">
                <div
                  className="h-full bg-[#4CAF50] rounded-full transition-all duration-300"
                  style={{ width: getProgressWidth(formData.others) }}
                ></div>
              </div>
            </div>
          </div> */}

          {/* Action Buttons */}
          <div className="flex gap-4">
            <button
              onClick={onClose}
              className="cursor-pointer flex-1 h-[56px] border-1 border-[#06323A] text-[#06323A] bg-white rounded-full text-base font-medium tracking-[0] leading-[normal] hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              className={`flex-1 h-[56px] text-white rounded-full text-base font-medium tracking-[0] leading-[normal] transition-colors 
               bg-[#0A3A44] hover:bg-opacity-90 cursor-pointer`}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditClubDetailsModal;
